import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import store from "./store";
Vue.use(Router);
let router = new Router({
    mode: "history",
    routes: [{
            path: "/",
            name: "home",
            meta: {
                requiresAuth: true,
            },
            component: () =>
                import ("./components/Common/Default"),
            children: [{
                    path: "/dashboard",
                    name: "dashboard",
                    props: true,
                    component: () =>
                        import ("./components/Dashboard/dashboard"),
                    meta: {
                        requiresAuth: false,
                    },
                },

                {
                    path: "SellerList",
                    name: "SellerList",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Seller/sellerList"),
                },
                {
                    path: "pendingSeller",
                    name: "pendingSeller",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Seller/pendingSeller"),
                },
                {
                    path: "customerList",
                    name: "customerList",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/User/customerList"),
                },
                {
                    path: "customerDetails",
                    name: "customerDetails",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/User/customerDetails"),
                },
                {
                    path: "customerEdit",
                    name: "customerEdit",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/User/customerEdit"),
                },
                // {
                //   path: "SellerInfo",
                //   name: "SellerInfo",
                //   meta: {
                //     requiresAuth: true,
                //   },
                //   component: () => import("./components/Seller/sellerInfo"),
                // },
                {
                    path: "SellerInfonew",
                    name: "SellerInfonew",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Seller/SellerInfonew"),
                },


                {
                    path: "editSeller",
                    name: "editSeller",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Seller/edit/editSellerProfile"),
                },
                {
                    path: "mainCategory",
                    name: "mainCategory",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Category/mainCategory"),
                },
                {
                    path: "category",
                    name: "category",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Category/category"),
                },
                {
                    path: "Subcategory",
                    name: "Subcategory",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Category/subCategory"),
                },
                {
                    path: "Product",
                    name: "product",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Products/products"),
                },
                {
                    path: "pendingProducts",
                    name: "pendingProducts",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Products/pendingProducts"),
                },
                {
                    path: "updatedProduct",
                    name: "updatedProduct",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Products/updatedProduct"),
                },
                {
                    path: "rejectedProduct",
                    name: "rejectedProduct",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Products/rejectedProduct"),
                },
                {
                    path: "notification",
                    name: "notification",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Notification/notification"),
                },
                {
                    path: "emailCampaign",
                    name: "emailCampaign",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/EmailCampaign/emailCampaign"),
                },
                {
                    path: "salesReport",
                    name: "salesReport",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Reports/salesReport.vue"),
                },
                {
                    path: "inventoryReport",
                    name: "inventoryReport",
                    meta: {
                        requiresAuth: true,
                    },
                    component: () =>
                        import ("./components/Reports/inventoryReport.vue"),
                },
                {
                    name: 'productDetails',
                    path: 'productDetails/:id',
                    component: () =>
                        import ('./components/Products/productDetails'),
                },
                {
                    name: 'ProductEdit',
                    path: 'productEdit',
                    component: () =>
                        import ('./components/Products/productEdit'),
                },
                {
                    name: 'homeSlider',
                    path: 'homeSlider',
                    component: () =>
                        import ('./components/Home/homeSlider'),
                },
                {
                    name: 'middleSlider',
                    path: 'middleSlider',
                    component: () =>
                        import ('./components/Home/middleSlider'),
                },
                {
                    name: 'promoCode',
                    path: 'promoCode',
                    component: () =>
                        import ('./components/Home/promoCode'),
                },
                {
                    name: 'productPromoCode',
                    path: 'productPromoCode',
                    component: () =>
                        import ('./components/PromoCode/productPromoCode'),
                },
                {
                    name: 'pendingPromoCode',
                    path: 'pendingPromoCode',
                    component: () =>
                        import ('./components/PromoCode/pendingPromoCode'),
                },
                {
                    name: 'updatedPromoCode',
                    path: 'updatedPromoCode',
                    component: () =>
                        import ('./components/PromoCode/updatedPromoCode'),
                },
                {
                    name: 'orderList',
                    path: 'orderList',
                    component: () =>
                        import ('./components/Order/orderList'),
                },
                {
                    name: 'orderDetails',
                    path: 'orderDetails',
                    component: () =>
                        import ('./components/Order/orderDetails'),
                },
                {
                    name: 'cancelledlist',
                    path: 'cancelledList',
                    component: () =>
                        import ('./components/Order/cancelledlist'),
                },
                {
                    name: 'footerData',
                    path: 'footerData',
                    component: () =>
                        import ('./components/Footer/footerData'),
                },
                {
                    path: 'static/:name',
                    name: 'static',
                    props: true,
                    component: () =>
                        import ('./components/static'),

                },
                {
                    name: 'contactList',
                    path: 'contactList',
                    component: () =>
                        import ('./components/Contact/contactList'),
                },
                {
                    name: 'contactDetails',
                    path: 'contactDetails',
                    component: () =>
                        import ('./components/Contact/contactDetails'),
                },
                {
                    name: 'reviewList',
                    path: 'reviewList',
                    component: () =>
                        import ('./components/UserReview/reviewList'),
                },
            ],
        },

        {
            path: "/",
            props: true,
            component: () =>
                import ("./components/Authentication/Authentication"),
            meta: {
                requiresAuth: false,
            },
            children: [{
                    path: "login",
                    name: "login",
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ("./components/Authentication/adminLogin"),
                },
                {
                    path: "login2",
                    name: "login2",
                    meta: {
                        requiresAuth: false,
                    },
                    component: () =>
                        import ("./components/Authentication/Login"),
                },
                // {
                //   path: "signup",
                //   name: "signup",
                //   meta: {
                //     requiresAuth: false,
                //   },
                //   component: () => import("./components/Authentication/Signup"),
                // },
            ],
        },

        {
            path: "*",
            name: "404pagenotfound",
            props: true,
            component: () =>
                import ("./components/Common/404"),
            meta: {
                requiresAuth: false,
            },
        },
        {
            path: "/servererror",
            name: "servererror",
            props: true,
            component: () =>
                import ("./components/Common/500"),
            meta: {
                requiresAuth: false,
            },
        },
    ],
    scrollBehavior() {
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0;
    },
});

router.beforeEach((to, from, next) => {
    if (
        to.matched.some((route) => route.meta.requiresAuth == true) &&
        store.state.isLoggedIn == false
    ) {
        console.log(from);
        next({ name: "login", params: { lastPage: from } });
        return;
    }

    if (
        (to.name == "login" || to.name == "home") &&
        store.state.isLoggedIn == true
    ) {
        next({ name: "dashboard" });
        return;
    }

    if (store.state.isLoggedIn == true) {
        axios({
                method: "POST",
                url: "/validate/token",
                headers: {
                    "x-auth-token": localStorage.getItem("token"),
                },
            })
            .then((response) => {
                if (!response.data.status) {
                    store.commit("sessionOut", true);
                    return;
                }
            })
            .catch((err) => {
                var msg = err;
                console.log(msg);
            });
    }

    next();
});

export default router;